import parse from "html-react-parser";
import moment from "moment";
import * as paths from "../constants/paths";
import axios from "axios";
export function doObjToFormData(obj) {
  var formData = new FormData();
  for (var key in obj) {
    if (Array.isArray(obj[key])) {
      for (let [keyv, value] of Object.entries(obj[key])) {
        formData.append(key + "[]", JSON.stringify(value));
      }
    } else {
      if (typeof obj[key] == "object") {
        formData.append(key, JSON.stringify(obj[key]));
      } else {
        formData.append(key, obj[key]);
      }
    }
  }
  return formData;
}

export function doObjToFormDataWithoutString(obj) {
  var formData = new FormData();
  for (var key in obj) {
    if (Array.isArray(obj[key])) {
      for (let [keyv, value] of Object.entries(obj[key])) {
        formData.append(key + "[]", value);
      }
    } else {
      if (typeof obj[key] == "object") {
        formData.append(key, obj[key]);
      } else {
        formData.append(key, obj[key]);
      }
    }
  }
  return formData;
}

export function doFirstUpperRestLower(word) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}

export function doParseHTML(string) {
  return parse(string);
}

export function getBackgroundImageUrl(src) {
  const base_api_url = paths.API_CMS_BG_IMAGES_URL;
  return base_api_url + src;
}

export function getBackgroundImageUrlThumb(src, thumb = 1) {
  const base_api_url = paths.API_CMS_BG_IMAGES_URL;
  if (thumb > 1) return base_api_url + thumb + "p_" + src;
  else return base_api_url + "thumb_" + src;
}

export function getUploadsUrl(folder, src) {
  const base_api_url = paths.API_UPLOADS_URL;
  return base_api_url + folder + "/" + src;
}

export function eventDateFormat(date) {
  return moment(date).format("DD MMMM YYYY");
}

export function eventTimeFormat(time) {
  return moment(time, "HHmm").format("hh:mm A");
}

export function eventTimeFormatNew(time) {
  return moment(time, "HHmm").format("hh A");
}

export function onlyDayThreeletters(date) {
  return moment(date).format("ddd");
}

export function onlyDateTwoletters(date) {
  return moment(date).format("DD");
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function nowPlus6Days() {
  let days = [];
  let daysRequired = 7;

  for (let i = 0; i <= daysRequired; i++) {
    days.push(moment().add(i, "days").format("YYYY-MM-DD"));
  }
  return days;
}

export function jobProgressColor(value) {
  switch (value) {
    case "application_in_progress":
    case "online_test_completed":
    // case "first_interview_completed":
    // case "second_interview_completed":
    case "interviewing":
    case "assessment_day_completed":
      return "_amber";
    case "offer_received":
      return "_green";
    case "online_test_failed":
    // case "first_interview_failed":
    // case "second_interview_failed":
    case "interview_failed":
    case "assessment_day_failed":
      return "_red";
    default:
      return "";
  }
}

export function getActiveClassname(value) {
  switch (value) {
    case 0:
      return "first_active";
    case 1:
      return "second_active";
    case 2:
      return "third_active";
    case 3:
      return "four_active";
    case 4:
      return "five_active";
    default:
      return "";
  }
}

export function makeSalaryString(min, max, interval) {
  min = Number(min);
  max = Number(max);
  if (min === 0 && max === 0) return "Competitive";
  else if (min > 0 && max === 0) return `${min} / ${interval}`;
  else if (min > 0 && max > 0) return `${min} - ${max} / ${interval}`;
  else return "Not Specified";
}

export function priceFormat(num) {
  if (num === null || num === "") return 0;

  const dec = num.split(".")[1];
  const len = dec && dec.length > 2 ? dec.length : 2;
  return Number(num).toFixed(len);
}

export function checkReferralLink(ref) {
  if (
    ref === undefined ||
    ref === "" ||
    ref === null ||
    ref == null ||
    ref === "null" ||
    ref === "null" ||
    ref === "undefined"
  ) {
    return false;
  } else {
    return true;
  }
}
export const getFileIcon = (ext) => {
  switch (ext) {
    case "pdf":
      return "/images/file_icon/pdf.png";
    case "doc":
    case "docx":
      return "/images/file_icon/doc.png";
    default:
      return "/images/file_icon/file.png";
  }
};
export function websiteLink(link) {
  const referralLink = localStorage.getItem("ref");
  const compaign_name = localStorage.getItem("compaign_name");

  if (checkReferralLink(referralLink))
    return `${link}?ref=${referralLink}&compaign_name=${compaign_name}`;
  else return link;
}

export function websiteLink_new(link) {
  const referralLink = localStorage.getItem("ref");
  const compaign_name = localStorage.getItem("compaign_name");

  const hasReferral = checkReferralLink(referralLink);
  const separator = link.includes("?") ? "&" : "?";
  const finalLink = hasReferral
    ? `${link}${separator}ref=${referralLink}&compaign_name=${compaign_name}`
    : link;

  if (link.startsWith("/open-jobs")) {
    window.location.href = `${window.location.origin}${finalLink}`;
    return;
  }

  window.location.href = `${window.location.origin}${finalLink}`;
}

export function postDateFormat(date) {
  return moment(date).format("DD - MMMM - YYYY");
}

export const getIpAddress = async () => {
  try {
    const response = await axios.get("https://api64.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    return "Unknown IP";
  }
};

export function timeAgo(date) {
  const momentDate = moment(date);
  const diff = moment().diff(momentDate);

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;
  const year = 365 * day;

  if (diff < minute) {
    return "Just now";
  } else if (diff < hour) {
    const minutes = Math.floor(diff / minute);
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else if (diff < day) {
    const hours = Math.floor(diff / hour);
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else if (diff < month) {
    const days = Math.floor(diff / day);
    return `${days} day${days > 1 ? "s" : ""} ago`;
  } else if (diff < year) {
    const months = Math.floor(diff / month);
    return `${months} month${months > 1 ? "s" : ""} ago`;
  } else {
    const years = Math.floor(diff / year);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  }
}

export function timeAgoShort(date) {
  const momentDate = moment(date);
  const diff = moment().diff(momentDate);

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const week = 7 * day;
  const month = 30 * day;
  const year = 365 * day;

  if (diff < minute) {
    return "Just now";
  } else if (diff < hour) {
    const minutes = Math.floor(diff / minute);
    return `${minutes}m ago`;
  } else if (diff < day) {
    const hours = Math.floor(diff / hour);
    return `${hours}h ago`;
  } else if (diff < week) {
    const days = Math.floor(diff / day);
    return `${days}d ago`;
  } else if (diff < month) {
    const weeks = Math.floor(diff / week);
    return `${weeks}w ago`;
  } else if (diff < year) {
    const months = Math.floor(diff / month);
    return `${months}mo ago`;
  } else {
    const years = Math.floor(diff / year);
    return `${years}y ago`;
  }
}

export function getCompanySponsorRating(value) {
  switch (value) {
    case "a_rated":
      return "A-Rated";
    case "b_rated":
      return "B-Rated";
    case "provisional":
      return "Provisional";

    default:
      return "N/A";
  }
}

export function getCompanyStrength(value) {
  switch (value) {
    case "weak":
      return "Weak";
    case "medium":
      return "Medium";
    case "strong":
      return "Strong";

    default:
      return "N/A";
  }
}

export function getCompanySponsorType(value) {
  switch (value) {
    case "active_sponsor":
      return "Active Sponsor";
    case "occasional_sponsor":
      return "Occasional Sponsor";
    case "inactive_sponsor":
      return "Inactive Sponsor";

    default:
      return "N/A";
  }
}

export function getSponsorTypeBadge(value) {
  switch (value) {
    case "active_sponsor":
      return (
        <div className={`sponsor_tag active`}>
          <img
            src={paths.SITE_BASE_URL + "/images/icon_mini_star.png"}
            alt="Active Sponsor"
          />
          Active Sponsor
        </div>
      );
    case "occasional_sponsor":
      return (
        <div className={`sponsor_tag occasional`}>
          <img
            src={paths.SITE_BASE_URL + "/images/icon_mini_refresh.png"}
            alt="Occasional Sponsor"
          />
          Occasional Sponsor
        </div>
      );
    case "inactive_sponsor":
      return (
        <div className={`sponsor_tag inactive`}>
          <img
            src={paths.SITE_BASE_URL + "/images/icon_mini_pause.png"}
            alt="Inactive Sponsor"
          />
          Inactive Sponsor
        </div>
      );

    default:
      return "N/A";
  }
}

 export function toSlugUrl(text) {
    
    text = text.trim();
    text = text.replace(/&quot/g, '');
    text = text.replace(/[^A-Za-z0-9-]+/g, '-');
    text = text.replace(/--+/g, '-');
    text = text.replace(/@/g, '-');
    return text.toLowerCase();
}

/**
 * Two letters from the first meaningful word of a company name.
 *
 * Not the first letter of two words: company names are not people's names,
 * so "Amazon UK Services Ltd" reads AM, not AU. Legal suffixes and articles
 * are skipped, so "The Francis Crick Institute" gives FR rather than TH.
 *
 * Shared by the directory card and the company page so one employer is never
 * two different monograms.
 */
const INITIALS_SKIP = /^(the|a|an|of|for|and|ltd|limited|plc|llp|lp|cic|uk|group)$/i;

export const initials = (name) => {
  const words = String(name || "")
    .replace(/[^A-Za-z ]/g, " ")
    .split(" ")
    .filter(Boolean);
  const first = words.find((w) => !INITIALS_SKIP.test(w)) || words[0];
  return first ? first.slice(0, 2).toUpperCase() : "–";
};
